import React from 'react';
import PageHeader from '../components/PageHeader';

const sections = [
  {
    icon: 'fa-check-circle',
    color: '#00C896',
    bg: '#e6fff6',
    title: 'Eligible for Refund',
    items: [
      'Duplicate payment made for the same plan within 24 hours',
      'Technical error on our platform that prevented access to paid features',
      'Plan purchased but service was unavailable for more than 72 consecutive hours',
      'Accidental purchase of a higher plan — request raised within 48 hours',
    ],
  },
  {
    icon: 'fa-times-circle',
    color: '#ef4444',
    bg: '#fff0f0',
    title: 'Not Eligible for Refund',
    items: [
      'Refund requests raised after 7 days of purchase',
      'Partial use of the plan (e.g., some job postings already published)',
      'Change of mind after the plan has been activated',
      'Violation of our Terms of Service leading to account suspension',
      'Free plan — no payment involved',
    ],
  },
];

const steps = [
  { icon: 'fa-envelope', title: 'Submit Request', desc: 'Email us at onexverabusinesssolutions@gmail.com with your order ID and reason.' },
  { icon: 'fa-search', title: 'Review', desc: 'Our team reviews your request within 2 business days.' },
  { icon: 'fa-check', title: 'Approval', desc: 'If eligible, we confirm the refund via email.' },
  { icon: 'fa-university', title: 'Refund Processed', desc: 'Amount credited to your original payment method within 5–7 business days.' },
];

export default function RefundPolicy() {
  return (
    <>
      <PageHeader title="Refund Policy" breadcrumb="Refund Policy" />
      <section className="section-pad">
        <div className="container" style={{ maxWidth: 860 }}>

          <div className="policy-intro">
            <div className="policy-intro-icon" style={{ background: '#e6fff6', color: '#00C896' }}><i className="fa fa-undo-alt"></i></div>
            <div>
              <h4>Our Refund Commitment</h4>
              <p>
                At <strong>JustHiring24</strong>, we want you to be completely satisfied with your purchase.
                This policy outlines the conditions under which refunds are granted for paid plans.
                Last updated: <strong>January 1, 2025</strong>.
              </p>
            </div>
          </div>

          <div className="policy-two-col">
            {sections.map((s, i) => (
              <div className="policy-section" key={i}>
                <div className="policy-section-title">
                  <div className="policy-section-icon" style={{ background: s.bg, color: s.color }}><i className={`fa ${s.icon}`}></i></div>
                  <h5>{s.title}</h5>
                </div>
                <ul className="policy-list">
                  {s.items.map((item, j) => (
                    <li key={j}>
                      <i className={`fa ${s.icon}`} style={{ color: s.color }}></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="policy-section">
            <div className="policy-section-title">
              <div className="policy-section-icon"><i className="fa fa-list-ol"></i></div>
              <h5>Refund Process</h5>
            </div>
            <div className="refund-steps">
              {steps.map((step, i) => (
                <div className="refund-step" key={i}>
                  <div className="refund-step-num">{i + 1}</div>
                  <div className="refund-step-icon"><i className={`fa ${step.icon}`}></i></div>
                  <h6>{step.title}</h6>
                  <p>{step.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="policy-section">
            <div className="policy-section-title">
              <div className="policy-section-icon" style={{ background: '#fff8e6', color: '#f59e0b' }}><i className="fa fa-clock"></i></div>
              <h5>Refund Timeline</h5>
            </div>
            <div className="refund-timeline-table">
              {[
                { method: 'Credit / Debit Card', time: '5–7 business days' },
                { method: 'UPI / Net Banking',   time: '3–5 business days' },
                { method: 'Wallet',              time: '1–2 business days' },
              ].map((row, i) => (
                <div className="refund-timeline-row" key={i}>
                  <span><i className="fa fa-credit-card me-2 text-primary"></i>{row.method}</span>
                  <span className="refund-timeline-badge">{row.time}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="policy-contact-box">
            <i className="fa fa-headset"></i>
            <div>
              <h6>Need help with a refund?</h6>
              <p>Reach us at <a href="mailto:onexverabusinesssolutions@gmail.com">onexverabusinesssolutions@gmail.com</a> or call <a href="tel:+919718094931">+91 97180 94931</a>.</p>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
